// src/router/index.js
import { createRouter, createMemoryHistory } from "vue-router"; // 内存模式
import MainMenu from "@/views/Menu.vue"; // 主菜单页面
import mapRoutes from "./map/maps"; // 引入地图子路由模块
import pveRoutes from "./pve/pve";
import pokedexRoutes from "./pokedex"; //moren pokedex's index.js
import movememory from "./movememory"; //技能唤醒，如果后续需要可以合并进其他路由index.js。

import flipgame from "./flipCardGame"; //翻卡游戏index.js。


import pokeevoRoutes from "./pokeevo"; // ✅ 新增引入进化仓模块

const routes = [
  {
    path: "/", // 根路径，加载菜单
    name: "MainMenu",
    component: MainMenu,
  },
  ...mapRoutes, // 加载地图模块的路由
  ...pveRoutes, //pve的路由
  ...pokedexRoutes, // 图鉴路由
	...movememory,//技能唤醒
	...flipgame,
  ...pokeevoRoutes, // ✅ 注册到主路由
];

export default createRouter({
  history: createMemoryHistory(), // 内存模式
  routes,
});
